// FacturaFormSection.jsx
import React from 'react'
import {
    Grid,
    Typography,
    Autocomplete,
    TextField,
    FormControlLabel,
    Checkbox,
    FormControl,
    FormLabel,
    RadioGroup,
    Radio,
    Button,
    TableContainer,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    IconButton
} from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'

export default function FacturaFormSection({
    suffix,
    clientes,
    isLoading,
    cliente,
    onClienteChange,
    onSearchClientes,
    identidad,
    identidadSec,
    puntosActuales,
    lempirasActuales,
    puntosActualesSec,
    lempirasActualesSec,
    dividirFactura,
    onDividirFacturaChange,
    showPolizaOptions,
    clienteSecundario,
    onClienteSecundarioChange,
    clienteOrigenChecked,
    onClienteOrigenCheckedChange,
    origenes,
    origen,
    onOrigenChange,
    polizaSplitOption,
    onPolizaSplitOptionChange,
    porcentajeClientePrincipal,
    onPorcentajeClientePrincipalChange,
    porcentajeClienteSecundario,
    onPorcentajeClienteSecundarioChange,
    montoClientePrincipal,
    onMontoClientePrincipalChange,
    montoClienteSecundario,
    onMontoClienteSecundarioChange,
    valorPagar,
    onValorPagarChange,
    montoPendiente,
    montoConfirmado,
    onMontoConfirmadoChange,
    tipoFactura,
    onTipoFacturaChange,
    ordenCompra,
    onOrdenCompraChange,
    ordenCompraExcenta,
    onOrdenCompraExcentaChange,
    constanciaRegistro,
    onConstanciaRegistroChange,
    registroSAG,
    onRegistroSAGChange,
    diasCredito,
    onDiasCreditoChange,
    transaccionesCajero,
    tipoDocumento,
    onTipoDocumentoChange,
    numero,
    onNumeroChange,
    valorPagado,
    onValorPagadoChange,
    documentos,
    onAgregarDocumento,
    onEliminarDocumento,
    cambio,
    tipoComprobante,
    onTipoComprobanteChange,
    loading,
    onSubmit,
    onCancel,
    isSecondary,
    disabledDespachar,
}) {
    return (
        <Grid container spacing={2} sx={{ mb: 4, pl: 1, pr: 1 }}>
            <Grid item xs={12}>
                <Typography variant="h6">
                    Datos de Factura {suffix}
                </Typography>
            </Grid>

            {/* Cliente / Identidad */}
            {(!dividirFactura || suffix === 'Cliente Principal') ? (
                <>
                    {/* === Cliente Principal === */}
                    <Grid item xs={12} sm={6}>
                        <Autocomplete
                            size="small"
                            options={clientes}
                            getOptionLabel={opt => opt.nombreCompleto}
                            loading={isLoading}
                            value={cliente}
                            onChange={(e, v) => onClienteChange(v)}
                            onInputChange={(e, search) => onSearchClientes?.(search)}
                            renderInput={params => <TextField {...params} label="Cliente Principal" fullWidth />}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            size="small"
                            label="Identidad"
                            value={identidad}
                            InputProps={{ readOnly: true }}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <TextField
                            size="small"
                            label="Puntos"
                            value={puntosActuales}
                            InputProps={{ readOnly: true }}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <TextField
                            size="small"
                            label="Lempiras"
                            value={lempirasActuales}
                            InputProps={{ readOnly: true }}
                            fullWidth
                        />
                    </Grid>
                </>
            ) : (
                <>
                    {/* === Cliente Secundario === */}
                    <Grid item xs={12} sm={6}>
                        <Autocomplete
                            size="small"
                            options={clientes}
                            getOptionLabel={opt => opt.nombreCompleto}
                            loading={isLoading}
                            value={clienteSecundario}
                            onChange={(e, v) => onClienteSecundarioChange(v)}
                            onInputChange={(e, search) => onSearchClientes?.(search)}
                            renderInput={params => <TextField {...params} label="Cliente Secundario" fullWidth />}
                            disabled={clienteOrigenChecked}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            size="small"
                            label="Identidad"
                            value={identidadSec}
                            InputProps={{ readOnly: true }}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <TextField
                            size="small"
                            label="Puntos"
                            value={puntosActualesSec}
                            InputProps={{ readOnly: true }}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <TextField
                            size="small"
                            label="Lempiras"
                            value={lempirasActualesSec}
                            InputProps={{ readOnly: true }}
                            fullWidth
                        />
                    </Grid>
                </>
            )}

            {/* Dividir factura */}
            {/* <Grid item xs={12}>
                <FormControlLabel
                    control={
                        <Checkbox
                            size="small"
                            checked={dividirFactura}
                            onChange={e => onDividirFacturaChange(e.target.checked)}
                        />
                    }
                    label="Dividir factura"
                />
            </Grid> */}

            {/* Lógica de póliza / montos principal/secundario */}
            {dividirFactura && showPolizaOptions ? (
                <Grid container spacing={2} sx={{ mb: 2, pl: 1, pr: 1 }}>
                    <Grid item xs={12} sm={4}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    size="small"
                                    checked={clienteOrigenChecked}
                                    onChange={e => onClienteOrigenCheckedChange(e.target.checked)}
                                />
                            }
                            label="Cliente Origen"
                        />
                    </Grid>
                    {clienteOrigenChecked && (
                        <Grid item xs={12} sm={6}>
                            <Autocomplete
                                size="small"
                                options={origenes}
                                getOptionLabel={opt => opt.descripcion || ''}
                                value={origen}
                                onChange={(e, v) => onOrigenChange(v)}
                                renderInput={params => <TextField {...params} label="Origen" fullWidth />}
                            />
                        </Grid>
                    )}
                    <Grid item xs={12}>
                        <FormControl component="fieldset" fullWidth>
                            <FormLabel component="legend">Cómo dividir según póliza</FormLabel>
                            <RadioGroup
                                row
                                value={polizaSplitOption}
                                onChange={e => onPolizaSplitOptionChange(e.target.value)}
                            >
                                <FormControlLabel value="noElegibleCopago" control={<Radio size="small" />} label="No elegible" />
                                <FormControlLabel value="aseguradoraAsegurado" control={<Radio size="small" />} label="Copago / No elegible" />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                </Grid>
            ) : dividirFactura ? (
                <Grid container spacing={2} sx={{ mb: 2, pl: 1, pr: 1 }}>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            size="small"
                            label="% Cliente Principal"
                            type="number"
                            value={porcentajeClientePrincipal}
                            onChange={e => onPorcentajeClientePrincipalChange(parseFloat(e.target.value))}
                            InputProps={{ inputProps: { min: 0, max: 100 } }}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            size="small"
                            label="% Cliente Secundario"
                            type="number"
                            value={porcentajeClienteSecundario}
                            onChange={e => onPorcentajeClienteSecundarioChange(parseFloat(e.target.value))}
                            InputProps={{ inputProps: { min: 0, max: 100 } }}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            size="small"
                            label="Monto Cliente Principal"
                            type="number"
                            value={montoClientePrincipal}
                            onChange={e => onMontoClientePrincipalChange(parseFloat(e.target.value))}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            size="small"
                            label="Monto Cliente Secundario"
                            type="number"
                            value={montoClienteSecundario}
                            onChange={e => onMontoClienteSecundarioChange(parseFloat(e.target.value))}
                            fullWidth
                        />
                    </Grid>
                </Grid>
            ) : null}

            {/* Valor a Pagar / Confirmado */}
            <Grid item xs={12} sm={4}>
            <TextField
                size="small"
                label="Valor a pagar"
                type="text"
                inputMode="decimal"
                value={Number(valorPagar) === 0 ? "" : valorPagar}
                onChange={e => onValorPagarChange(e.target.value)}
                error={parseFloat(valorPagar || 0) > montoPendiente + 0.01}
                helperText={`Pendiente: L. ${montoPendiente.toFixed(2)}`}
                fullWidth
            />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FormControlLabel
                    control={
                        <Checkbox
                            size="small"
                            checked={montoConfirmado}
                            onChange={e => onMontoConfirmadoChange(e.target.checked)}
                        />
                    }
                    label="Monto Confirmado"
                />
            </Grid>

            {/* Tipo de Factura */}
            <Grid item xs={12} sm={4}>
                <FormControl component="fieldset">
                    <FormLabel component="legend">Tipo de Factura</FormLabel>
                    <RadioGroup row value={tipoFactura} onChange={e => onTipoFacturaChange(e.target.value)}>
                        <FormControlLabel value="contado" control={<Radio size="small" />} label="Contado" />
                        <FormControlLabel value="credito" control={<Radio size="small" />} label="Crédito" />
                    </RadioGroup>
                </FormControl>
            </Grid>

            {/* Campos específicos para Factura a Crédito */}
            {tipoFactura === 'credito' && (
                <>
                    <Grid item xs={12}>
                        <Typography variant="subtitle2" sx={{ mt: 2, mb: 1, fontWeight: 'bold', color: 'primary.main' }}>
                            Datos para Factura al Crédito
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            size="small"
                            label="Orden de Compra"
                            value={ordenCompra}
                            onChange={e => onOrdenCompraChange(e.target.value)}
                            fullWidth
                            placeholder="Ingrese número de orden de compra"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            size="small"
                            label="Orden de Compra Exenta"
                            value={ordenCompraExcenta}
                            onChange={e => onOrdenCompraExcentaChange(e.target.value)}
                            fullWidth
                            placeholder="Ingrese número de orden exenta"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            size="small"
                            label="Constancia de Registro"
                            value={constanciaRegistro}
                            onChange={e => onConstanciaRegistroChange(e.target.value)}
                            fullWidth
                            placeholder="Ingrese registro de exonerados"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            size="small"
                            label="Registro SAG"
                            value={registroSAG}
                            onChange={e => onRegistroSAGChange(e.target.value)}
                            fullWidth
                            placeholder="Ingrese número de registro SAG"
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            size="small"
                            label="Días de Crédito"
                            type="number"
                            value={diasCredito}
                            onChange={e => onDiasCreditoChange(parseInt(e.target.value) || 30)}
                            fullWidth
                            inputProps={{ min: 1, max: 365 }}
                            placeholder="Días de crédito"
                        />
                    </Grid>
                </>
            )}

            {/* Órdenes y Registros (solo para facturas de contado) */}
            {tipoFactura === 'contado' && (
                <>
                    <Grid item xs={12} sm={3}>
                        <TextField
                            size="small"
                            label="Orden de Compra"
                            value={ordenCompra}
                            onChange={e => onOrdenCompraChange(e.target.value)}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <TextField
                            size="small"
                            label="Orden de Compra Exenta"
                            value={ordenCompraExcenta}
                            onChange={e => onOrdenCompraExcentaChange(e.target.value)}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <TextField
                            size="small"
                            label="Constancia de Registro"
                            value={constanciaRegistro}
                            onChange={e => onConstanciaRegistroChange(e.target.value)}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <TextField
                            size="small"
                            label="Registro SAG"
                            value={registroSAG}
                            onChange={e => onRegistroSAGChange(e.target.value)}
                            fullWidth
                        />
                    </Grid>
                </>
            )}

            {/* Documentos - Solo para facturas al contado */}
            {tipoFactura === 'contado' && (
                <>
                    <Grid item xs={12}>
                        <Typography variant="h6">Documentos {suffix}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Autocomplete
                            size="small"
                            options={transaccionesCajero}
                            getOptionLabel={opt => opt.descripcionTipoTransaccion || ''}
                            value={transaccionesCajero.find(i => i.id === tipoDocumento) || null}
                            onChange={(e, v) => onTipoDocumentoChange(v?.id)}
                            renderInput={params => <TextField {...params} label="Tipo de Documento" fullWidth />}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <TextField size="small" label="Numero" value={numero} onChange={e => onNumeroChange(e.target.value)} fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <TextField
                            size="small"
                            label="Valor Pagado"
                            type="number"
                            value={valorPagado}
                            onChange={e => onValorPagadoChange(e.target.value)}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Button size="small" variant="contained" fullWidth onClick={onAgregarDocumento}>
                            Agregar
                        </Button>
                    </Grid>

                    {/* Tabla de Documentos */}
                    <Grid item xs={12}>
                        <TableContainer component={Paper}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Tipo de Documento</TableCell>
                                        <TableCell>Número</TableCell>
                                        <TableCell>Valor</TableCell>
                                        <TableCell>Acciones</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {documentos.map((doc, i) => (
                                        <TableRow key={i}>
                                            <TableCell>{doc.descripcion}</TableCell>
                                            <TableCell>{doc.numero}</TableCell>
                                            <TableCell>{doc.valorPagado.toFixed(2)}</TableCell>
                                            <TableCell>
                                                <IconButton onClick={() => onEliminarDocumento(i)}>
                                                    <DeleteIcon />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </>
            )}

            {/* Cambio - Solo mostrar para facturas al contado */}
            {tipoFactura === 'contado' && (
                <>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="h6">Cambio</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            size="small"
                            label="Cambio"
                            type="number"
                            value={cambio.toFixed(2)}
                            InputProps={{ readOnly: true }}
                            fullWidth
                        />
                    </Grid>
                </>
            )}

            {/* Tipo de Impresión */}
            <Grid item xs={12}>
                <FormControl component="fieldset">
                    <FormLabel component="legend">Tipo de Impresión</FormLabel>
                    <RadioGroup row value={tipoComprobante} onChange={e => onTipoComprobanteChange(e.target.value)}>
                        <FormControlLabel value="Carta" control={<Radio size="small" />} label="Carta" />
                        <FormControlLabel value="Ticket" control={<Radio size="small" />} label="Ticket" />
                    </RadioGroup>
                </FormControl>
            </Grid>

            {/* Botones */}
            <Grid container spacing={2} justifyContent="flex-end">
                <Grid item xs={12} sm={3}>
                    <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        fullWidth
                        onClick={() => onSubmit(isSecondary)}
                         disabled={disabledDespachar || loading || (isSecondary ? montoClienteSecundario <= 0 : montoClientePrincipal <= 0)}
                    >

                        {loading
                            ? 'Procesando…'
                            : tipoFactura === 'contado'
                                ? 'Despachar'
                                : 'Facturar crédito'}
                    </Button>

                </Grid>
                <Grid item xs={12} sm={3}>
                    <Button
                        size="small"
                        variant="contained"
                        color="secondary"
                        onClick={onCancel}
                        fullWidth
                    >
                        Cancelar
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    )
}
